<template>
    <div>
        <config-main-title>
            Layout de Arquivo de Retorno (CSV)
        </config-main-title>


        <div class="row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn"
                        :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn"
                        :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir()">
                    Incluir Layout
                </button>
            </div>
        </div>

        <az-empty-state v-if="!lista || !lista.length" />

        <div v-else>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + id"
                                v-model="dado.fl_ativo" @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>
        <layout-arquivo-retorno-modal @refresh="refresh()" ref="layoutArquivoModal" />
    </div>
</template>

<script>
import ConfigMainTitle from "@/components/cadastros/shared/ConfigMainTitle.vue";
import AzInput from "@/components/shared/forms/AzInput.vue";
import LayoutArquivoRetornoModal from "@/components/shared/LayoutArquivoRetornoModal.vue";

export default {

    components: {
        AzInput,
        ConfigMainTitle,
        LayoutArquivoRetornoModal
    },

    data() {
        return {
            breadcrumb: null,
            dados: null,
            search: '',
            viewMode: 'A',
        }
    },

    computed: {
        lista: function () {
            if (!this.dados)
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => {
                return (item.fl_ativo || this.viewMode == 'T') &&
                    (!this.search || reg.test(JSON.stringify(item)))
            });

        },
    },

    methods: {

        incluir() {
            this.$refs.layoutArquivoModal.open();
        },

        editar(item) {
            this.$refs.layoutArquivoModal.open(item);
        },

        toggle(item) {
            this.$util.toggle(this, {
                service: 'layout-arquivo-retorno',
                dados: item,
            });

        },

        refresh() {
            this.$util.load(this, {
                service: 'layout-arquivo-retorno',
                function: 'index'
            });
        }
    },

    mounted() {

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Layout de Arquivo de Retorno" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.load(this, {
            service: "layout-arquivo-retorno",
            function: "index"
        })
    }
}
</script>
<style scoped></style>
